import { object, string } from 'yup';

import i18n from '@app/i18n/config';

import { urlRegEx } from '@shared/regexps';

export const websiteSchema = object({
  website: string().test(
    'urlRegEx',
    i18n.t('COMMON:errors.incorrectWebsite'),
    (value) => (value?.length ? urlRegEx.test(value!) : true)
  ),
});
